import React from "react";
import { List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import FavoriteIcon from "@material-ui/icons/Favorite";
import { Link } from "react-router-dom";
import { makeStyles, Drawer, Divider } from "@material-ui/core";
import "./styles.css";

const estilos = makeStyles((theme) => ({
  drawer: {
    width: 240,
    flexShrink: 0,
  },
  drawerPaper: {
    width: 240,
    background: "#005457",
  },
  toolbar: theme.mixins.toolbar,
}));

const Cajon = ({ accionAbrir, open, onClose, formState }) => {
  const classes = estilos();

  return (
    <Drawer
      className={classes.drawer}
      classes={{
        paper: classes.drawerPaper,
      }}
      anchor="left"
      variant="temporary"
      open={open}
      onClose={onClose ? onClose : null}
    >
      <div className={classes.toolbar}></div>
      <Divider />
      <div>
        <List component="nav">
          <Link to="/" className="link" onClick={() => accionAbrir()}>
            <ListItem button>
              <ListItemText primary="Inicio" />
              <ListItemIcon>
                <FavoriteIcon />
              </ListItemIcon>
            </ListItem>
          </Link>

          <Link to="/test" className="link" onClick={() => accionAbrir()}>
            <ListItem button>
              <ListItemText primary="Test" />
              <ListItemIcon>
                <FavoriteIcon />
              </ListItemIcon>
            </ListItem>
          </Link>

          {formState.name !== "" || formState.age !== 0 ? (
            formState.radioAFiebre == "end" &&
            formState.radioBTos == "end" &&
            formState.radioCGarganta == "end" &&
            formState.radioDDiarrea == "end" &&
            formState.radioEOlfato == "end" &&
            formState.radioFErupciones == "end" &&
            formState.radioGColor == "end" &&
            formState.radioHRespirar == "end" ? (
              <Link
                to="/resultadosTres"
                className="link"
                onClick={() => accionAbrir()}
              >
                <ListItem button>
                  <ListItemText primary="Resultados" />
                  <ListItemIcon>
                    <FavoriteIcon />
                  </ListItemIcon>
                </ListItem>
              </Link>
            ) : formState.radioHRespirar == "start" ? (
              <Link
                to="/resultadosDos"
                className="link"
                onClick={() => accionAbrir()}
              >
                <ListItem button>
                  <ListItemText primary="Resultados" />
                  <ListItemIcon>
                    <FavoriteIcon />
                  </ListItemIcon>
                </ListItem>
              </Link>
            ) : (
              <Link
                to="/resultados"
                className="link"
                onClick={() => accionAbrir()}
              >
                <ListItem button>
                  <ListItemText primary="Resultados" />
                  <ListItemIcon>
                    <FavoriteIcon />
                  </ListItemIcon>
                </ListItem>
              </Link>
            )
          ) : (
            <>
            <ListItem button >
                  <ListItemText primary="Resultados" className="link"/>
                  <ListItemIcon>
                    <FavoriteIcon />
                  </ListItemIcon>
                </ListItem>
            </>
          )}

          <Link to="/acercade" className="link" onClick={() => accionAbrir()}>
            <ListItem button>
              <ListItemText primary="Acerca de" />
              <ListItemIcon>
                <FavoriteIcon />
              </ListItemIcon>
            </ListItem>
          </Link>
        </List>
      </div>
    </Drawer>
  );
};

export default Cajon;
